import {apiToTransaction, apiToPortfolio} from '@/services/converters'
import dateUtils from '@/helpers/dateUtils'

function apiToUpload(data) {
  return {
    id: data.id,
    status: data.status,
    filename: data.meta.fileName,
    uploadTime: dateUtils.formatDateTime(new Date(data.created)),
    errorMsg: data.output ? data.output.reason : null,
    user: apiToUser(data.creator),
  }
}

function apiToGroup({id, name}) {
  return {id, name}
}

function apiToUser(data) {
  let user = data
  user.name = data.firstName + ' ' + data.lastName
  if (data.role === 'client') {
    user.portfolios = data.portfolios ? data.portfolios.map(portfolio => portfolio.id) : []
    user.cgroups = user.cgroups ? user.cgroups.map(g => g.id) : []
  }
  return user
}

export {
  apiToTransaction,
  apiToPortfolio,
  apiToUser,
  apiToUpload,
  apiToGroup,
}



// WEBPACK FOOTER //
// ./src/-service-app/services/converters.js